/**
 * @file CircleButton.js
 * @module src/js/components/CircleButton
 * @description
 * **A reusable circular button component with optional tooltip support.**
 * - Accepts props for opacity, click handling, tooltip configuration, margins, and disabled state.
 * - Styles the button to be circular and centers its content.
 * - Integrates with `react-tooltip` for displaying tooltips on hover.
 *
 * @version
 * <p>
 *  2025-11-24: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { Tooltip } from 'react-tooltip'

export default function CircleButton({
    opacity = 1,
    onClick,
    tooltipId = null,
    tooltipMessage = "",
    marginLeft = '0',
    marginBottom = '0',
    outline = 'inherit',
    outlineOffset = 'inherit',
    children,
    disabled = false,
}) {
    return (
        <>
            <button
                type='button'
                data-tooltip-id={tooltipId}
                data-tooltip-content={tooltipMessage}
                data-tooltip-place="top"
                disabled={disabled}
                style={{
                    marginLeft,
                    marginBottom,
                    position: "relative", // Ensures text stays on top of gradient
                    width: '27px',
                    height: '27px',
                    borderRadius: '45%',
                    padding: '0',
                    paddingLeft: '0em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: disabled ? 0.4 : opacity,
                    outline,
                    outlineOffset,
                    transition: "opacity 0.5s ease-in-out"
                }}
                onClick={onClick}
            >
                {children}
            </button>
            {tooltipId && tooltipMessage !== "" && (
                <Tooltip
                    id={tooltipId}
                    style={{ textTransform: 'none' }}
                />
            )}
        </>
    );
}